import { AddSGBPCategoryData } from "../Component/addSGBPCategory/data/AddSGBPCategory.data";
import { EditSGBPCategoryData } from "../Component/editSGBPCategory/data/EditSGBPCategory.data";
import { SGBPCategoryCriteriaData } from "../data/SGBPCategoryCriteriaData";

export const setAllDropDownField = (apiResponse, useEditTypeList = false) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({ value: item.id, label: item.name });
            }
            return acc;
        }, []);
    };

    const dropdownLists = {
        "searchbyCode":filterDropDownList("Criteria Code"),
        "statusId": filterDropDownList("Requirement Section Status"),
        "categoryId": filterDropDownList("L1"),
        "subCategoryId": filterDropDownList("L2"),
        "typeId": filterDropDownList("L3"),
        "channel": filterDropDownList("Channel"),
        "category": filterDropDownList("L1"),
        "subCategory": filterDropDownList("L2"),
        "type": filterDropDownList(useEditTypeList ? "Type L3 Edit" : "Type L3"),
        "code": filterDropDownList("Criteria Code"),
        "certificateTemplate": filterDropDownList("Certificate Template"),
    };

    const formFields = [
        ...SGBPCategoryCriteriaData.formFields,
        ...AddSGBPCategoryData.formFields,
        ...EditSGBPCategoryData.formFields,
    ];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};